import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { TranslationsKeys, useCustomIntl } from '../../../../i18n/i18n';

type FuellingImage = {
  image: string;
  alt: TranslationsKeys;
  className?: string;
};

export const ServicesFuellingChapter = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();

  const driverAppTeaserImage = getImageAssetWithLocale(
    imageKeys.driverAppTeaser,
    locale,
  );

  const googleplayImages: FuellingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.manPlayStoreQr, locale),
      alt: 'userManual.googleplayQRCodeImageAlt',
      className: 'border',
    },
    {
      image: getImageAssetWithLocale(imageKeys.playStore, locale),
      alt: 'userManual.googleplayImageAlt',
    },
  ];

  const appstoreImages: FuellingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.manAppleStoreQr, locale),
      alt: 'userManual.appstoreImageAlt',
      className: 'border',
    },
    {
      image: getImageAssetWithLocale(imageKeys.appStore, locale),
      alt: 'userManual.appstoreQRCodeImageAlt',
    },
  ];

  return (
    <div>
      <div className={'row col-xs-12'}>
        <ChapterHeadline
          messageId={'userManual.chapter.services.fuelling.headline'}
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            colSize={12}
            messageId={'userManual.chapter.services.fuelling.headline.text'}
            referenceToChapter="servicesMobileFuelling"
          />
          <div className={'col-xs-12'}>
            <div className="col-xs-12 display-flex gap-10 padding-0">
              <div className="col-xs-5 padding-0">
                <ImageLoader
                  className="border"
                  src={driverAppTeaserImage}
                  alt={formatMessage({
                    id: 'userManual.driverAppTeaserImageAlt',
                  })}
                  enlargeable
                />
              </div>
              <div className="col-xs-6">
                <div className="display-flex gap-10 flex-column">
                  {googleplayImages.map(({ image, alt, className }) => {
                    return (
                      <div
                        key={alt}
                        className={'col-xs-6 padding-0'}
                      >
                        <ImageLoader
                          className={className}
                          src={image}
                          alt={formatMessage({ id: alt })}
                          enlargeable
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="display-flex gap-10 margin-top-10 flex-column">
                  {appstoreImages.map(({ image, alt, className }) => {
                    return (
                      <div
                        key={alt}
                        className={'col-xs-6 padding-0'}
                      >
                        <ImageLoader
                          className={className}
                          src={image}
                          alt={formatMessage({ id: alt })}
                          enlargeable
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
